import { SelectList } from '@acies/core';
import SearchItemRenderer from './search-item-renderer';
import type ISearchResult from './search-result';

/**
 * The SelectList the SearchAutoComplete popover renders the results of a search with.
 *
 * The metrics are the DropdownList ones, so a result row sits in the popover exactly like a DropdownItem row does.
 */
export default class SearchList<Item extends ISearchResult> extends SelectList<Item> {
	public constructor() {
		super();
		this.paddingHorizontal = 4;
		this.paddingVertical = 4;
		this.width = 'fill';
		this.gapVertical = 4;
		this.ItemRenderer = SearchItemRenderer;
	}
}
customElements.define('cf-search-list', SearchList);
